import React from "react";

const Overview = () => {
  return (
    <div id={"overview"}>
      <h3>Overview</h3>
      <p>
        SOTI Blockly is a block-based visual programming environment that aims
        to provide SOTI customers with a beginner-friendly interface for writing
        custom scripting logic. Instead of writing error-prone text-based code,
        you can create logic flows by dragging and dropping
        &#39;blocks&#39; onto a canvas.
        <br />
        <br />
        Each block performs a different function such as navigating to a new
        page or displaying a popup message in a SOTI Snap app.

        <div className={"imageContainer"}>

          <img src="/images/navigate.png" alt="Navigate"/>
          <img src="/images/display-message.png" alt="display message" />
          
        </div>

        You can connect blocks to other blocks to create more complicated
        logical statements. The shape of a block indicates where it can be
        connected.
        <br />
        <div className={"imageContainer"}>
          <img src="/images/statementConnect.gif" alt="statementConnect" />
          <img src="/images/roundConnect.gif" alt="roundConnect" />
          <img src="/images/hexagonalConnect.gif" alt="hexagonalConnect" />
        </div>
        <br />
        You can find all available blocks in the &#39;Toolbox&#39; on the left
        side of the workspace. Click on a block category to open a menu where
        you can select blocks within that category.
        <br />
        <div className={"imageContainer"}>
          <img src="/images/toolboxDemo.gif" alt="Toolbox" />
        </div>
        <br />
        Hover your mouse cursor on a block or toolbox category to reveal a
        tooltip with a brief description of its use. Find detailed documentation
        on each of the available blocks here:
      </p>

      <ul>
        <li><a href="#overview">Overview</a></li>
        <li><a href="#widget-values">Widget Values</a></li>
        <li><a href="#app-actions">App Actions</a></li>
        <li><a href="#connections">Connections</a></li>
        <li><a href="#code-blocks">Code Blocks</a></li>
        <li><a href="#XSight Topics">XSight Topics</a></li>
        <li><a href="#logic">Logic</a></li>
        <li><a href="#loops">Loops</a></li>
        <li><a href="#math">Math</a></li>
        <li><a href="#text">Text</a></li>
        <li><a href="#lists">Lists</a></li>
        <li><a href="#colours">Colours</a></li>
        <li><a href="#dates">Dates</a></li>
        <li><a href="#variables">Local and Global Variables</a></li>
        <li><a href="#Repeater">Repeater</a></li>
        <li><a href="#Table">Table</a></li>
        <li><a href="#MobiControl">MobiControl</a></li>
        <li><a href="#debug-tools">Debug Tools</a></li>
      </ul>
    </div>
  );
};

export default Overview; 
